
export const faqs = [
    {
        q: {
            tr: "Cevher Jant Hangi Sektörde Faaliyet Göstermektedir?",
            en: "Which sector does Cevher Jant operate in?",
        },
        a: {
            tr: "Şirket Esas Sözleşmesi’nin “Amaç ve Konu” başlıklı 3’üncü maddesi uyarınca Şirket, demir madeni dışında kalan (non ferro) her türlü metal ve madenler ile plastikten her çeşit motorlu veya motorsuz araçların, ulaşım vasıtaları jantlarının, aktarma organlarının, motor ve alet edevatlarının aksam, cihazların ve yedek parçalarının mamul veya yarı mamul üretimini, alım satımını yapmak üzere faaliyetlerde bulunmak amacıyla kurulmuş olup, 6102 sayılı TTK, 6362 sayılı SPKn ve SPK düzenlemeleri ve sermaye piyasası mevzuatına uymak suretiyle faaliyet göstermektedir.",
            en: "Pursuant to Article 3 titled “Purpose and Subject” of the Company’s Articles of Association, the Company was established to engage in activities for the manufacture and the purchase and sale of finished or semi-finished products made of all kinds of metals and minerals other than iron (non-ferrous; “non ferro”) and plastics, including the wheels (rims) of all types of motorized or non-motorized vehicles and means of transportation, powertrain components, engines, tools and equipment, components, devices, and spare parts; and it carries out its activities in compliance with the Turkish Commercial Code No. 6102, the Capital Markets Law No. 6362, the regulations of the Capital Markets Board (CMB), and the capital markets legislation.",
        },
    },
    {
        q: { tr: "Cevher Jant Ne Zaman ve Nerede Kurulmuştur?", en: "When and where was Cevher Jant founded?" },
        a: {
            tr: "Şirket, 19.07.2002 tarihinde İzmir’de mevcut unvanıyla tescil edilerek kurulmuştur.",
            en: "The Company was established upon registration in İzmir under its current trade name on 19.07.2002."
        },
    },
    {
        q: { tr: "Cevher Jant’ın Sermaye ve Ortaklık Yapısı Nasıldır?", en: "What is the share capital and ownership structure?" },
        a: {
            tr: "Çıkarılmış sermayesi 300.000.000 TL olup tamamen ödenmiştir. Ortaklık yapısı için lütfen Kurumsal Yönetim sekmesindeki “Ortaklık Yapısı” tablosunu ziyaret ediniz.",
            en: "Its issued capital amounts to TRY 300,000,000 and has been fully paid in. For the shareholding structure, please refer to the Partnership Structure” table under the Corporate Governance section."
        },
    },
    {
        q: { tr: "Cevher Jant Payları Borsada Ne Zaman İşlem Görmeye Başladı?", en: "When did the shares start trading?" },
        a: { tr: "-", en: "-" },
    },
    {
        q: { tr: "Cevher Jant’ın BIST Kodu Nedir?", en: "What is the BIST ticker?" },
        a: { tr: "Cevher Jant paylarının BIST kodu CEVHR’dir.", en: "The BIST code of Cevher Jant shares is CEVHR." },
    },
    {
        q: { tr: "Cevher Jant’ın Halka Açıklık Oranı Nedir?", en: "What is the free float ratio?" },
        a: { tr: "Cevher Jant’ın halka açıklık oranı %25,33’tür.", en: "Cevher Jant’s free float ratio is 25.33%." },
    },
    {
        q: { tr: "Cevher Jant’ın Payları Hangi Pazarda İşlem Görmektedir?", en: "Which market segment do the shares trade on?" },
        a: { tr: "BİST Yıldız Pazar’da işlem görmektedir.", en: "It is traded on the BIST Yıldız Market." },
    },
    {
        q: { tr: "Cevher Jant’ın hisse senetlerini nasıl alabilirim?", en: "How can I buy Cevher Jant shares?" },
        a: {
            tr: "Hisse senedi alım satım işlemleri SPK'dan lisanslı aracı kurumlar aracılığı ile sadece Borsa İstanbul'da oluşan fiyat seviyelerinden gerçekleştirilebilir. Bir hisse senedine yatırım yapmak için banka/aracı kurum hesabınızın altında bir yatırım hesabı açmanız gerekir. Başka hiçbir kanaldan hisse senedi alım/satımı yapılamaz. Ayrıca bu konuyla ilgili hisse alım/satım yaptığınız banka/aracı kurumu arayarak detaylı bilgi alabilirsiniz.",
            en: "Share trading transactions may be conducted only at the price levels formed on Borsa İstanbul through intermediary institutions licensed by the SPK. To invest in a share, you must open an investment account under your bank/brokerage account. Share purchase/sale cannot be carried out through any other channel. In addition, you can obtain detailed information on this matter by calling the bank/brokerage firm through which you execute your share purchase/sale."
        },
    },

    {
        q: { tr: "Cevher Jant’ın Faaliyet Dönemi (Mali Yıl) Ne Zamandır?", en: "What is the fiscal year period?" },
        a: {
            tr: "Cevher Jant’ın faaliyet dönemi (mali yılı) 1 Ocak – 31 Aralık arasıdır.",
            en: "Cevher Jant’s fiscal year is from January 1 to December 31."
        },
    },
    {
        q: { tr: "Cevher Jant’ın Dahil Olduğu Endeksler Nelerdir?", en: "Which indices is the company included in?" },
        a: { tr: "-", en: "-" },
    },
    {
        q: { tr: "Cevher Jant’ın Faaliyet Raporuna Nereden Ulaşabilirim?", en: "Where can I find the annual report?" },
        a: { tr: "Faaliyet Raporu için lütfen Raporlar sekmesindeki “Faaliyet Raporları” bölümünü ziyaret ediniz.", en: "For the Annual Report, please visit the “Annual Reports” section under the Reports tab." },
    },
    {
        q: { tr: "Cevher Jant’ın Finansal Raporuna Nereden Ulaşabilirim?", en: "Where can I find the financial reports?" },
        a: { tr: "Finansal Rapor için lütfen “Finansal Sonuçlar” bölümünü ziyaret ediniz.", en: "For the Financial Report, please visit the “Financial Results” section." },
    },
    {
        q: { tr: "Cevher Jant’ın esas sözleşmesine nereden ulaşabilirim?", en: "Where can I find the articles of association?" },
        a: {
            tr: 'Cevher Jant’ın esas sözleşmesine Kamuyu Aydınlatma Platformu üzerinden veya <a href="/investor-relations/articles-of-association" target="_blank" rel="noopener noreferrer">buradan</a> ulaşabilirsiniz.',
            en: 'You can access Cevher Jant’s articles of association via the Public Disclosure Platform or <a href="/investor-relations/articles-of-association" target="_blank" rel="noopener noreferrer">here</a>.'
        },
    },
    {
        q: { tr: "Cevher Jant’ın Genel Kurul Tarihi Nedir?", en: "When is the General Assembly date?" },
        a: { tr: "-", en: "-" },
    },
    {
        q: { tr: "Cevher Jant yatırımcıları sorular için kimlerle iletişime geçebilir?", en: "Who should investors contact?" },
        a: { tr: "Sorularınızı yatirimci@cevher.com mail adresine veya 0 232 298 20 00 (238) dahili numarasından yatırımcı ilişkilerine bağlanarak iletebilirsiniz.",
             en: "You can send your questions to the email address yatirimci@cevher.com or reach Investor Relations by dialing 0 232 298 20 00 (ext. 238)."
            },
    },
];